<script setup lang="ts">
import { ref, toRefs, onMounted, watch } from "vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    default: "",
  },
  showValue: {
    type: Boolean,
    default: true,
  },
});
const emits = defineEmits(["update:showValue"]);
const { id, content } = toRefs(props);

const vditorElement: any = ref(null);
watch(content, () => {
  if (vditorElement.value) {
    try{
      vditorElement.value.setValue(content.value);
    } catch (e) {
      console.error('e',e);
    }}
});

onMounted(async () => {
  // @ts-ignore
  vditorElement.value = new Vditor(`vditor-${id.value}`, {
    width: "100%",
    readOnly: true,
    toolbar: [],
    cache: {
      enable: false,
    },
    mode: "wysiwyg",
    after: () => {
      emits("update:showValue", false);
      vditorElement.value.setValue(content.value);
      vditorElement.value.disabled();
    },
  });
});

</script>

<template>
  <div :id="'vditor-' + id" class="vditor-window"></div>
</template>

<style lang="scss">
@import url("/vditorjs/dist/index.css");
.vditor-window {
  border: none !important;
  overflow-x: scroll;
  overflow-y: hidden;

  .vditor-content {
    min-height: 0 !important;
  }

  .vditor-wysiwyg__pre {
    display: none !important;
  }

  .vditor-toolbar {
    border-bottom: none;
  }

  ::v-deeppre.vditor-reset[contenteditable="false"] {
    opacity: 1;
  }

  .vditor-reset {
    font-size: 14px;
    padding: 0 !important;
    background-color: transparent !important;
    user-select: text;
    color: #666666 !important;
    cursor: text !important;
    opacity: 1 !important;

    pre > code {
      overflow-x: hidden;
    }

    table {
      width: 100% !important;
      max-width: 100%;
      display: inline-table;
      cursor: text;
      margin-bottom: 0 !important;

      th {
        padding: 10px 0 !important;
        white-space: pre-wrap !important;
      }

      td {
        padding: 10px 0 !important;
        text-align: center;
        white-space: pre-wrap !important;
      }
    }
  }

  .vditor-panel {
    display: none !important;
  }

  .hljs {
    white-space: break-spaces;
    border: 1px solid #d9d9d9 !important;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .vditor-tooltipped__w {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 30px;
    top: 0;
    right: 0;
    padding: 0 15px;
    z-index: 9999;
    // background-color: #cccccc !important;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .vditor-tooltipped__w::after {
    display: block !important;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    line-height: 30px;
    font-size: 13px;
    padding: 0;
    color: #777777;
    background: transparent;
    position: absolute;
    top: -15px;
    right: 30px;
    z-index: 99999;
    opacity: 1;
    content: "复制";
  }

  .vditor-tooltipped__w:active {
    height: 35px;
  }

  .mermaid {
    white-space: pre-wrap;
  }
}

.vditor-img {
  .vditor-img__btn:first-child {
    display: none;
  }

  .vditor-img__img {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      transform: none !important;
    }
  }
}
</style>
